import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQ } from "../data/content";

export default function FAQSection() {
    const [open, setOpen] = useState(0);

    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-24 sm:py-32 border-t border-white/5"
        >
            <div className="max-w-3xl mx-auto px-6 sm:px-10">
                <div className="text-center mb-14">
                    <div className="overline mb-5">Objections, Addressed</div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl text-[#f4f4f0]">
                        Questions a{" "}
                        <span className="italic text-[#990000]">
                            careful man
                        </span>{" "}
                        asks.
                    </h2>
                </div>

                <div className="divide-y divide-white/5 border-y border-white/5">
                    {FAQ.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <div key={i} data-testid={`faq-item-${i}`}>
                                <button
                                    onClick={() =>
                                        setOpen(isOpen ? -1 : i)
                                    }
                                    data-testid={`faq-trigger-${i}`}
                                    className="w-full text-left flex items-center justify-between gap-6 py-7 group"
                                    aria-expanded={isOpen}
                                >
                                    <span className="font-serif-display text-xl sm:text-2xl text-[#f4f4f0] group-hover:text-[#990000] transition-colors duration-300">
                                        {item.q}
                                    </span>
                                    <span
                                        className={`font-serif-display text-2xl text-[#7A0000] transition-transform duration-500 ${
                                            isOpen ? "rotate-45" : ""
                                        }`}
                                    >
                                        +
                                    </span>
                                </button>
                                <AnimatePresence initial={false}>
                                    {isOpen && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{
                                                height: "auto",
                                                opacity: 1,
                                            }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{
                                                duration: 0.45,
                                                ease: [0.16, 1, 0.3, 1],
                                            }}
                                            className="overflow-hidden"
                                        >
                                            <p className="pb-7 pr-12 text-neutral-400 leading-relaxed">
                                                {item.a}
                                            </p>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
